// Private-warehouse vendors: the vendor catalogue (GET /payees/:id/products)
// carries `warehouseCostPerBaseUnit` — the warehouse's selling price brought
// down to one of the buyer's base units. The PO line cost is prefilled from it
// (buyers can still edit it); other vendors keep the product's own cost.

function baseQtyFor(product: { units?: { unitName?: string; baseQty?: string | number }[] }, unit: string): number {
  if (!unit || unit.toLowerCase() === 'each') return 1;
  const row = (product.units ?? []).find((u) => u.unitName?.toLowerCase() === unit.toLowerCase());
  return Number(row?.baseQty) || 1;
}

export function prefillLineCost(
  product: {
    cost?: string | number | null;
    warehouseCostPerBaseUnit?: number | null;
    units?: { unitName?: string; baseQty?: string | number }[];
  },
  unit: string,
): string {
  if (product.warehouseCostPerBaseUnit != null) {
    return (Number(product.warehouseCostPerBaseUnit) * baseQtyFor(product, unit)).toFixed(2);
  }
  return String(product.cost ?? '0') || '0';
}

/** A warehouse vendor linked to another tenant's (private) warehouse. */
export function isPrivateWarehouseVendor(
  payee: { vendorType?: string; linkedWarehouseId?: string | null } | undefined,
  tenantId: string | null | undefined,
): boolean {
  return (
    !!payee && payee.vendorType === 'warehouse' && !!payee.linkedWarehouseId && payee.linkedWarehouseId !== tenantId
  );
}
